module.exports = __webpack_public_path__ + "img/加好友.8cab5038.png";